interface Accessory {
  accessoryCode: string
  sublevel?: any
  familyId?: number
  subFamily?: any
  applicationLocation?: any
  model?: string
  attributes?: {
    finish?: any
    ledColourTemp?: any
    control?: any
    installation?: any
    pendantHeight?: any
  }
  quantity: number
  lumensLed?: any
  watts?: any
  articleType?: any
  productLength?: any
}

interface rawAccessory {
  articleCode: string
  drivers: Array<{
    count: number
    driverCode: string
  }>
}

const getDrivers = () => {
  // 1: "DALI",
  // 2: "0-10V",
  // 3: "1-10V+Pulsador",
  // 4: "TRIAC",
  // 5: "Pulsador",
  // 6: "Sensor",
  // 7: "Lutron",
  // A: "Dali 1-10V Pulsador",
  // B: "1-10V Pulsador",
  // C: "Dali 1-10V",
  // D: "Dali Push",
  // E: "Casambi PTP On-off",
  // F: "Dali 1-10-Push Casambi",
  // E: "Casambi PTP on-Off"

  return [
    {
      "model": "0270",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 3,
              "Z": "A40480/0Z",
              "A": "A40380/0A",
              "B": "A00180/0A"
            },
            {
              "number_support": 5,
              "0": "A00880/0B"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "0345",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 3,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 4,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 5,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A020-80/01",
              "2": "A028-80/02"
            },
            {
              "number_support": 3,
              "1": "A020-80/01",
              "2": "A032-80/02",
              "7": "A030-80/07"
            },
            {
              "number_support": 4,
              "2": "A032-80/02",
              "7": "A031-80/07"
            },
            {
              "number_support": 5,
              "7": "A031-80/07"
            },
            {
              "number_support": 6,
              "A": "A017-80/0A"
            },
            {
              "number_support": 7,
              "A": "A017-80/0A"
            },
            {
              "number_support": 8,
              "A": "A017-80/0A"
            }
          ]
        }
      ]
    },
    {
      "model": "0361",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 3,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 4,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 5,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A020-80/01",
              "2": "A028-80/02"
            },
            {
              "number_support": 3,
              "1": "A020-80/01",
              "2": "A032-80/02",
              "7": "A030-80/07"
            },
            {
              "number_support": 4,
              "2": "A032-80/02",
              "7": "A031-80/07"
            },
            {
              "number_support": 5,
              "7": "A031-80/07"
            },
            {
              "number_support": 6,
              "A": "A017-80/0A"
            },
            {
              "number_support": 7,
              "A": "A017-80/0A"
            },
            {
              "number_support": 8,
              "A": "A017-80/0A"
            }
          ]
        }
      ]
    },
    {
      "model": "0820",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A04380/0Z",
              "A": "A04380/0Z"
            },
            {
              "number_support": 3,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 4,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 5,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 6,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 7,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 8,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            },
            {
              "number_support": 9,
              "Z": "A04380/0Z",
              "A": "A00380/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A023-80/0B"
            },
            {
              "number_support": 3,
              "1": "A020-80/01",
              "7": "A035-80/07"
            },
            {
              "number_support": 4,
              "1": "A020-80/01",
              "7": "A035-80/07"
            },
            {
              "number_support": 5,
              "1": "A020-80/01",
              "7": "A035-80/07"
            },
            {
              "number_support": 6,
              "A": "A018-80/0A",
              "7": "A036-80/07"
            },
            {
              "number_support": 7,
              "A": "A018-80/0A",
              "7": "A036-80/07"
            },
            {
              "number_support": 8,
              "A": "A018-80/0A",
              "7": "A036-80/07"
            },
            {
              "number_support": 9,
              "A": "A018-80/0A",
              "7": "A036-80/07"
            }
          ]
        }
      ]
    },

    {
      "model": "0920",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 3,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 4,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 5,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 6,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 7,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 8,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            },
            {
              "number_support": 9,
              "1": "A00580/01",
              "Z": "A04580/0Z",
              "B": "A00880/0B"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A020-80/01",
              "2": "A023-80/0B"
            },
            {
              "number_support": 3,
              "1": "A020-80/01",
              "2": "A028-80/02",
              "7": "A030-80/07"
            },
            {
              "number_support": 4,
              "1": "A020-80/01",
              "2": "A032-80/02",
              "7": "A030-80/07"
            },
            {
              "number_support": 5,
              "1": "A020-80/01",
              "2": "A032-80/02",
              "7": "A031-80/07"
            },
            {
              "number_support": 6,
              "2": "A032-80/02",
              "A": "A017-80/0A",
              "7": "A031-80/07"
            },
            {
              "number_support": 7,
              "2": "A034-80/02",
              "A": "A017-80/0A",
              "7": "A031-80/07"
            },
            {
              "number_support": 8,
              "2": "A034-80/02",
              "A": "A017-80/0A",
              "7": "A031-80/07"
            },
            {
              "number_support": 9,
              "2": "A034-80/02",
              "A": "A017-80/0A"
            }
          ]
        }
      ]
    },
    {
      "model": "2350",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 3,
              "1": "A01580/01",
              "3": "A01280/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 4,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A033-80/01",
              "3": "A024-80/03"
            },
            {
              "number_support": 3,
              "1": "A033-80/01"
            },
            {
              "number_support": 4,
              "1": "A026-80/01"
            }
          ]
        }
      ]
    },
    {
      "model": "2351",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 3,
              "1": "A01580/01",
              "3": "A01280/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 4,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A033-80/01",
              "3": "A024-80/03"
            },
            {
              "number_support": 3,
              "1": "A033-80/01"
            },
            {
              "number_support": 4,
              "1": "A026-80/01"
            }
          ]
        }
      ]
    },
    {
      "model": "2355",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 3,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 4,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 5,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            },
            {
              "number_support": 6,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            },
            {
              "number_support": 7,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 8,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 9,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A033-80/01",
              "3": "A025-80/03"
            },
            {
              "number_support": 3,
              "1": "A033-80/01",
              "3": "A024-80/03"
            },
            {
              "number_support": 4,
              "1": "A026-80/01"
            }
          ]
        }
      ]
    },
    {
      "model": "5520",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 3,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 4,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 5,
              "1": "A01580/01",
              "3": "A01280/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 6,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            },
            {
              "number_support": 7,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 8,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 9,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A033-80/01",
              "3": "A025-80/03"
            },
            {
              "number_support": 3,
              "1": "A033-80/01",
              "3": "A024-80/03"
            },
            {
              "number_support": 4,
              "1": "A033-80/01"
            }
          ]
        }
      ]
    },
    {
      "model": "5525",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 3,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 4,
              "1": "A01580/01",
              "3": "A01080/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 5,
              "1": "A01580/01",
              "3": "A01280/03",
              "Z": "A04980/0Z"
            },
            {
              "number_support": 6,
              "1": "A01380/01",
              "3": "A01280/03",
              "Z": "A04780/0Z"
            },
            {
              "number_support": 7,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 8,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            },
            {
              "number_support": 9,
              "1": "A01480/01",
              "Z": "A04880/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A033-80/01",
              "3": "A025-80/03"
            },
            {
              "number_support": 3,
              "1": "A033-80/01",
              "3": "A024-80/03"
            },
            {
              "number_support": 4,
              "1": "A033-80/01"
            }
          ]
        }
      ]
    },
    {
      "model": "5660",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "A": "A00180/0A",
              "Z": "A04180/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5662",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "A": "A00180/0A",
              "Z": "A04180/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5664",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "A": "A00180/0A",
              "Z": "A04180/0Z"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5770",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 3,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 4,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 5,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 6,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 3,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 4,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5772",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 3,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 4,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 5,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 6,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 3,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 4,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5774",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 3,
              "1": "A00480/01",
              "Z": "A04480/0Z",
              "B": "A00780/0B"
            },
            {
              "number_support": 4,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 5,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            },
            {
              "number_support": 6,
              "Z": "A04180/0Z",
              "A": "A00180/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 3,
              "1": "A019-80/01",
              "2": "A038-80/02",
              "7": "A039-80/07"
            },
            {
              "number_support": 4,
              "2": "A038-80/02",
              "7": "A029-80/07"
            }
          ]
        }
      ]
    },
    {
      "model": "5935",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            },
            {
              "number_support": 3,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A034-80/02"
            }
          ]
        }
      ]
    },
    {
      "model": "6160",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            },
            {
              "number_support": 3,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A034-80/02"
            }
          ]
        }
      ]
    },
    {
      "model": "6165",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            },
            {
              "number_support": 3,
              "Z": "A04280/0Z",
              "A": "A00280/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": [
            {
              "number_support": 2,
              "2": "A034-80/02"
            }
          ]
        }
      ]
    },
    {
      "model": "7450",
      "catalog": [
        {
          "name": "row",
          "list_drivers": []
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "7455",
      "catalog": [
        {
          "name": "row",
          "list_drivers": []
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "7460",
      "catalog": [
        {
          "name": "row",
          "list_drivers": []
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "7470",
      "catalog": [
        {
          "name": "row",
          "list_drivers": []
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "7475",
      "catalog": [
        {
          "name": "row",
          "list_drivers": []
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "3235",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A040780/0Z",
              "A": "A040680/0A"
            },
            {
              "number_support": 3,
              "Z": "A040780/0Z",
              "A": "A040680/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    },
    {
      "model": "5730",
      "catalog": [
        {
          "name": "row",
          "list_drivers": [
            {
              "number_support": 2,
              "Z": "A50780/0Z",
              "A": "A50680/0A"
            },
            {
              "number_support": 3,
              "Z": "A50780/0Z",
              "A": "A50680/0A"
            }
          ]
        },
        {
          "name": "usa",
          "list_drivers": []
        }
      ]
    }
  ];
}

const getTotalDrivers = (groupLight) => {
  let listTotalDrivers = groupLight.map(function (groupLightElement) {
    let listDrivers = getDrivers();

    let positionArrayModel = listDrivers.findIndex((listDriverElement) => groupLightElement.articleCode == listDriverElement.model);

    //If model not exist, return empty
    if (positionArrayModel == -1) {
      return { "articleCode": groupLightElement.articleCode, "drivers": [] };
    }

    //Get result by catalog
    let driversByCatalog = listDrivers[positionArrayModel].catalog.map(function (listDriverElement) {
      let drivers = [];
      let nameCatalog = listDriverElement.name;

      //Get number of luminaries by driver and support
      let listNumberDriversHaveThisController = getListDriversByModelSupport(listDriverElement, groupLightElement);

      if (listNumberDriversHaveThisController.length === 0) {
        return { [nameCatalog]: drivers };
      }

      //Algorithm drivers needed
      var arrayclusters = calculateDriversNeed(groupLightElement, listNumberDriversHaveThisController);

      //Reduce array return calculateDriversNeed
      let occurrences = arrayclusters.reduce(function (acc, curr) {
        return acc[curr] ? ++acc[curr] : acc[curr] = 1, acc
      }, {});

      //Make return value
      for (const [key, element] of Object.entries(occurrences)) {
        let positionNumber = listNumberDriversHaveThisController.findIndex((iterator) => iterator.number_luminaries_support.toString() == key);

        if (positionNumber == -1) {
          positionNumber = listNumberDriversHaveThisController.findIndex((iterator) => iterator.number_luminaries_support.toString() == Number(key) + 1);
        }

        if (positionNumber != -1) {
          drivers.push({ "driverCode": listNumberDriversHaveThisController[positionNumber].keyDriver, "count": element })
        }
      }

      //Stack drivers with same reference
      let driversStacked = drivers.reduce(function (previus, actual) {
        let index = previus.findIndex((iterator) => iterator.driverCode == actual.driverCode);

        if (index === -1) {
          return [
            ...previus,
            { "driverCode": actual.driverCode, "count": actual.count }
          ]
        } else {
          previus[index].count += actual.count
          return [...previus]
        }

      }, []);

      return { [nameCatalog]: driversStacked };
    });

    return { 'articleCode': groupLightElement.articleCode, 'drivers': driversByCatalog };

  });

  return parseTotalDrivers(listTotalDrivers);
}

interface totalRawAccessories {
  usa: rawAccessory[]
  row: rawAccessory[]
}

function parseTotalDrivers(totalDrivers): totalRawAccessories {

  function parseDriver(driver) {
    const parsedDriver = driver.reduce((acc, act) => {
      return { ...acc, ...act }
    }, {})
    return parsedDriver
  }

  const parsedCatalogsInDriver = totalDrivers.map(driver => ({
    ...driver,
    drivers: parseDriver(driver.drivers)
  }))

  const parsedCatalogs = parsedCatalogsInDriver.reduce((acc, act) => {
    const result = acc
    result.usa.push({ ...act, drivers: act.drivers.usa ?? [] })
    result.row.push({ ...act, drivers: act.drivers.row ?? [] })
    return result
  }, { usa: [], row: [] })

  return parsedCatalogs
}

function parseToAccessories(rawAccessories: rawAccessory[]): Accessory[] {
  const result = []
  rawAccessories?.forEach(rawAccessory => {
    rawAccessory.drivers?.forEach(elem => {
      result.push({
        accessoryCode: elem.driverCode,
        quantity: elem.count,
        model: rawAccessory.articleCode
      })
    })
  })
  return result
}

function calculateDriversNeed(groupLightElement: any, listNumberDriversHaveThisController: any) {
  var totalLamps = groupLightElement.count;
  var nummaxcluster = listNumberDriversHaveThisController[0].number_luminaries_support;

  var totalclusters = Math.ceil(totalLamps / nummaxcluster);
  var lampspercluster = Math.floor(totalLamps / totalclusters);
  var restlamps = totalLamps % totalclusters;
  var arrayclusters = new Array(totalclusters).fill(undefined);

  arrayclusters.forEach(myFunction);

  function myFunction(item, index, arr) {
    if (restlamps !== 0) {
      arr[index] = lampspercluster + 1;
      restlamps--;
    } else {
      //In case not exist cluster add one to lamppercluster
      let positionClusterNumber = listNumberDriversHaveThisController.findIndex((iterator) => iterator.number_luminaries_support == lampspercluster);
      if (positionClusterNumber == -1) {
        //If driver not exist, add 1 tu cluster
        arr[index] = lampspercluster + 1;
      } else {
        arr[index] = lampspercluster;
      }
    }
  }
  return arrayclusters;
}

function getListDriversByModelSupport(listDriverElement: { name: string; list_drivers: any[]; }, groupLightElement: any) {
  return listDriverElement.list_drivers.reduce((acc, element) => {
    return element[groupLightElement.articleControlCode] ? [
      ...acc,
      { "number_luminaries_support": element.number_support, "keyDriver": element[groupLightElement.articleControlCode] }
    ] : acc;
  }, []).sort((a, b) => b.number_luminaries_support - a.number_luminaries_support);
}

export default { getTotalDrivers, parseToAccessories, getDrivers }